export function passwordValidator(p1, t) {
  if (p1 == "") {
    return "";
  }

  if (p1.length < 8) {
    return t("validator.password","Password must be longer than 8 characters");
  }

  let pattern = /(?=.*[a-zA-Z]+)(?=.*[0-9]+)[A-Za-z\d!@#$%^&*()\-_=+\[\]\{\},<.>~?]{8,}/;
  let matches = p1.match(pattern);

  if (matches == null) {
    return t("validator.password-special","Password must include at least 1 special character, and 1 number");
  }

  return "";
}

export function passwordMatch(p1, p2, t) {
  if (p1 == "" || p2 == "") {
    return "";
  }

  if (p1 != p2) {
    return t("validator.password-match","Passwords do not match");
  }

  return "";
}
